// @ts-check

if (!customElements.get("ct-range-list")) {
  class CtRangeList extends HTMLElement {
    constructor() {
      super();

      const paramName = this.dataset.ctParamName;
      const values = JSON.parse(this.dataset.ctValues);
      const unit = this.dataset.ctUnit || "";

      const sorted = [...values].sort(
        (a, b) => a.numericValue - b.numericValue
      );
      const absMin = sorted[0].numericValue;
      const absMax = sorted[sorted.length - 1].numericValue;

      const minSlider = this.querySelector("[data-min-price]");
      const maxSlider = this.querySelector("[data-max-price]");
      const minDisplay = this.querySelector("[data-min-value]");
      const maxDisplay = this.querySelector("[data-max-value]");
      const rangeTrack = this.querySelector("[data-range-track]");

      const range = absMax - absMin;
      const step = range / 200;
      // Visual gap: minimum % of track between the two thumbs (default 16%)
      const minGapPercent = parseFloat(this.dataset.ctMinGapPercent) || 16;
      const minGap = Math.max(step, (minGapPercent / 100) * range);

      [minSlider, maxSlider].forEach((s) => {
        s.min = absMin;
        s.max = absMax;
        s.step = step;
      });

      const activeMin = parseFloat(this.dataset.ctActiveMin || absMin);
      const activeMax = parseFloat(this.dataset.ctActiveMax || absMax);
      minSlider.value = activeMin;
      maxSlider.value = activeMax;

      const updateValues = () => {
        let min = parseFloat(minSlider.value);
        let max = parseFloat(maxSlider.value);

        if (min > max - minGap) {
          if (document.activeElement === minSlider) {
            min = max - minGap;
            minSlider.value = min;
          } else {
            max = min + minGap;
            maxSlider.value = max;
          }
        }

        const minPercent = ((min - absMin) / range) * 100;
        const maxPercent = ((max - absMin) / range) * 100;

        const suffix = unit ? " " + unit : "";
        minDisplay.textContent = Math.round(min) + suffix;
        maxDisplay.textContent = Math.round(max) + suffix;

        rangeTrack.style.left = minPercent + "%";
        rangeTrack.style.width = maxPercent - minPercent + "%";
      };

      updateValues();
      minSlider.addEventListener("input", updateValues);
      maxSlider.addEventListener("input", updateValues);

      const emitFilter = () => {
        const min = parseFloat(minSlider.value);
        const max = parseFloat(maxSlider.value);

        const selectedValues = sorted
          .filter((v) => v.numericValue >= min && v.numericValue <= max)
          .map((v) => v.value);

        this.dispatchEvent(
          new CustomEvent("ct-range-list-filter", {
            detail: { paramName, values: selectedValues },
          })
        );
      };

      minSlider.addEventListener("change", emitFilter);
      maxSlider.addEventListener("change", emitFilter);
    }
  }

  customElements.define("ct-range-list", CtRangeList);
}
